import IncorrectEmail from "./IncorrectEmail";
import React from "react";

export const EmailVerified = (): React.ReactElement => {
  return <div/>
}

export default EmailVerified;
